

import React,{Component} from 'react';

import {Link} from 'react-router-dom';

import axios from 'axios';

class UsersReposViewComponent extends Component{




    constructor (props)
{
    super(props)

    this.state = 
                {
                    username: null,
                    data: [],
                    loading:true
                }

}


async componentDidMount(){
    //catch route get parameters
    let urlParam = this.props.match.params.username;

    if((urlParam !== null) && (urlParam !== ""))
    {
        //set username value in state
        this.setState({username: urlParam});
    }
    else
    {
        alert("Bad request!");
        this.props.history.push("/gitsearch/");
    }

    //check if user is registered and logged in

    try{
    //get user access token
    let token = localStorage.getItem("token");
					
    if((token === "noToken") || (token === null))
    {
    alert("Ilegal page view");
    this.props.history.push("/gitsearch/");
    }

    let userDataResponse = await axios({
    method: "get",
    url: "http://mofehintolumumuni.com/gitserver/api/users/profile",
    headers: {"Authorization": "Bearer "+token}
    });

    let requestStatus = userDataResponse.data.status;
    //let payload = userDataResponse.data.data

    if(requestStatus !== "success")
    {

        //redirect away from dashboard
        this.props.history.push("/gitsearch/");

    }
   

    }
    catch(error)
    {
        alert("Cannot view resource please refresh page."+error);
        this.props.history.push("/gitsearch/");
    }



    //make axios call to API

    try{
        let token = localStorage.getItem("token");
					
        if((token === "noToken") || (token === null))
        {
        alert("Ilegal page view");
        this.props.history.push("/gitsearch/");
        }

        let response = await axios({
            method: "get",
            url: `http://mofehintolumumuni.com/gitserver/api/users/preference/github/usersearch/showOne/repos/${this.state.username}`,
            headers: {"Authorization": "Bearer "+token}
        });

        let status = response.data.status;

        if(status === "success")
        {
            this.setState({loading:false});
            this.setState({data: response.data.data});
        }
        else{
            this.setState({loading:false});
            alert("Bad request");
            this.props.history.push("/gitsearch/");
        }
    
    }
    catch(error)
    {
        this.setState({loading:false});
        alert("An error occurred while loading data from Github server, please refresh your page and try again.");
    }


}




render()
{
    const data = this.state.data;

    var userList = [];
    if(data.length > 0)
    {
    //get object from array
    let outterObject = data[0];

    //get array from object
    let mainObject = Object.values(outterObject)[0];


     userList = mainObject.map(repo =>
        {
            

            let image = repo.owner.avatar_url;
            

            let createdAtDate = repo.created_at.split("T")[0];
           

            let createdAtTime = repo.created_at.split("T")[1].split("Z")[0];
         

            let createdAt = `${createdAtDate} at ${createdAtTime}`;

            


            let updatedAtDate = repo.updated_at.split("T")[0];
           

            let updatedAtTime = repo.updated_at.split("T")[1].split("Z")[0];
         

            let updatedAt = `${updatedAtDate} at ${updatedAtTime}`;



            let pushedAtDate = repo.pushed_at.split("T")[0];
           

            let pushedAtTime = repo.pushed_at.split("T")[1].split("Z")[0];
         

            let pushedAt = `${pushedAtDate} at ${pushedAtTime}`;
           

            return(
            <li key={repo.id}>
          
            <img src={image} title="githubUserImage" alt={repo.owner.login} />
            <section className="list-left">
            <h5 className="title">Repo: {repo.full_name}</h5>
            <h5 className="title">Description: {repo.description}</h5>
            <span className="adprice">Repo Owner: {repo.owner.login}</span>
            <p className="catpath">Repo Clone Link: {repo.clone_url}</p>
            <p className="catpath">Repo Watchers: {repo.watchers}</p>
            <p className="catpath">Language in Repo : {repo.language}</p>
            <p className="catpath">Forks: {repo.forks_count}</p>
            <p className="catpath">Repo Created on: {createdAt}</p>
            <p className="catpath">Repo Updated on: {updatedAt}</p>
            <p className="catpath">Repo Pushed on: {pushedAt}</p>
            

            </section>
            <section className="list-right">
            <span className="date"><a href={repo.html_url}>View Repo on Github</a></span>
            <span className="date"><a href={repo.owner.html_url}>View Repo Owner on Github</a></span>
            <span className="date"><a href={repo.homepage}>View repo web platform</a></span>
            
          
            </section>
            <div className="clearfix"></div>
            </li> 
            )

        });
    }

return(

                   	<React.Fragment>
        <div className="banner text-center">
			<div className="container">    
				  <h1>Welcome to gitSearch <span className="segment-heading"> This application allows you to store </span> Github usernames, organization usernames, and issues.</h1>
				  <p>You would get search results for repository information, events, gists etc... directly from Github once you store Github usernames, organization usernames, and issues</p>
				  <div className="personal-details">
						<Link to="/gitsearch/login">SAVE GITHUB DATA </Link> 
				<br></br>
                <br></br>
						</div>
			</div>
	</div>

	<div className="total-ads main-grid-border">
		<div className="container">
		<div class="select-box">
				
				<div class="clearfix"></div>
			</div>
			
			<div className="ads-grid">
				
            <div className="side-bar col-md-3">
          
          <div className="search-hotel">
          <h4 className="sear-head">gitSearch</h4>
          <p>Number 1. Github Search tool !</p>
          
          
          </div>
          </div>

				<div className="ads-display col-md-9">
                {(this.state.loading) ? <h3>Loading data from Server <i className="fa fa-cogs" ></i> </h3> : null}
					<div className="wrapper">					
					<div className="bs-example bs-example-tabs" role="tabpanel" data-example-id="togglable-tabs">
					  <ul id="myTab" className="nav nav-tabs nav-tabs-responsive" role="tablist">
						<li role="presentation" className="active">
						  <a href="#home" id="home-tab" role="tab" data-toggle="tab" aria-controls="home" aria-expanded="true">
							<span className="text">Search Result</span>
						  </a>
						</li>
						
					  </ul>
					  <div id="myTabContent" className="tab-content">
						<div role="tabpanel" className="tab-pane fade in active" id="home" aria-labelledby="home-tab">
						   <div>
								<div id="container">
							
								<div className="clearfix"></div>
							<ul className="list">
							
                            {userList}


							</ul>
						</div>
							</div>
						</div>
						
					  </div>
					</div>
				</div>
				</div>
				<div className="clearfix"></div>
			</div>
		</div>	
	</div>
</React.Fragment>
  
           
);

}



}




export default UsersReposViewComponent;
